import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";
import {
    Table,
    TableHead,
    TableCell,
    TableBody,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import VideoCategoryIcon from "../../../images/request/online-video.svg";
import {
    BASE_URL,
    DOWNLOAD_DOCUMENT,
    DOWNLOAD_DOCUMENT_BY_REQUEST_AND_ZIP,
    FILE_SUBTYPE_PDF,
    FILE_TYPE_APPLICATION,
    FILE_TYPE_IMAGE,
    FILE_TYPE_VIDEO,
    XS,
} from "../../../constants/constants";
import TableRow from "@material-ui/core/TableRow";
import {
    PAGE_DOWNLOAD_REQUEST_DOCUMENT,
} from "../../../constants/apiSuffix";
import moment from "moment";
import qs from "qs";
import DocPdfIcon from "../../../images/request/document/doc_pdf.svg";
import DocIcon from "../../../images/request/document/doc.svg";

import {connect} from "react-redux";
import GetAppIcon from "@material-ui/icons/GetApp";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import GeneralModal from "../../../theme/Modal/GeneralModal";
import ContentPreviewModal2 from "../../../theme/Modal/ContentPreviewModal2";


const styles = (theme) => ({
    filesUploadManager: {
        padding: "10px 0 10px 10px",

        "& .listFiles": {
            maxHeight: 400,
            overflowY: "auto",
            paddingRight: 10,

            "&::-webkit-scrollbar": {
                height: 9,
                width: 9,
            },
            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },
            "&::-webkit-scrollbar-thumb": {
                borderRadius: 6,
                background: "#7579bb",
                zIndex: 999,
            },
            "& .noDocument": {
                padding: 10,
                textAlign: "center",
                width: '100%'
            },
            "& table": {},
            "& thead": {
                "& tr": {
                    "& th": {
                        position: 'sticky',
                        top: 0,
                        backgroundColor: "#e6edfc",
                        borderBottom: "1px dashed #8da9d6",
                        padding: '5px 16px',
                        color: "#7579bb",
                        textTransform: "uppercase",
                        zIndex: 5,
                        [theme.breakpoints.down(XS)]: {
                            fontSize: "0.8rem",
                        },
                    },
                },
            },
            "& tbody": {

                "& tr": {
                    "& td": {
                        border: "none",
                        padding: 5,
                        borderTop: "5px solid #e6edfc",
                        borderBottom: "5px solid #e6edfc",
                        height: 60,
                    },
                },
                "& .buttonAction": {
                    width: 50,
                    "& svg": {
                        cursor: "pointer",
                        "& path": {
                            fill: "#c2c2df",
                        },
                    },

                },
                "& .columnDocInfoWrapper": {
                    position: "relative",
                    overflowY: "hidden",
                },
                "& .docInfo": {
                    display: "flex",
                    "& .fileView": {
                        width: 80,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "& .image": {
                            height: 36,
                            width: 60,
                            objectFit: "cover",
                        },
                    },
                    "& .docName": {
                        maxWidth: 240,
                        padding: "10px",
                        color: "#3939b7",
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        borderRadius: 5,

                        [theme.breakpoints.down(XS)]: {
                            fontSize: "0.75rem",
                        },

                    },
                },
                "& .dateView": {
                    color: "#323292",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    [theme.breakpoints.down(XS)]: {
                        fontSize: "0.75rem",
                    },
                },
            },
        },
    },
    previewModal: {
        maxHeight: '90vh',
        '&.full-width-modal':{
            [theme.breakpoints.down(XS)]: {
                minHeight: '90vh'
            },
            '& .show-file-content': {
                height: '100%'
            }
        },
        '& .bodyModalWrapper':{
            height: 'calc(100% - 70px)',
            maxHeight: 'calc(100% - 70px)',
            padding: '10px 20px 30px 20px',

        }
    }
});

class RequestDocumentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileView: null,
        };
    }

    handleCloseModal = () => {
        this.setState({
            fileView: null,
        });
    };

    downloadFileAction = (item) => {
        let hrefPage = window.location.href;
        // if(hrefPage.indexOf("?") > -1){
        //     hrefPage+=`&${OPEN_MODAL_FILE_UPLOAD_BY_REQUEST}=1&requestId=${this.props.requestId}&page=`
        // }
        const params = {
            documentId: item.id,
            typeDownload: DOWNLOAD_DOCUMENT,
            urlPageBeforeDownload: hrefPage,
        };
        window.location =
            BASE_URL + PAGE_DOWNLOAD_REQUEST_DOCUMENT + "?" + qs.stringify(params);
    };

    viewFileAction = (item) => {
        this.setState({
            fileView: item,
        });
    };

    downloadAllFileDocument = () => {
        const {requestDocumentList} = this.props;
        if (requestDocumentList.length > 1) {
            let hrefPage = window.location.href;
            // if(hrefPage.indexOf("?") > -1){
            //     hrefPage+=`&${OPEN_MODAL_FILE_UPLOAD_BY_REQUEST}=1&page=`
            // }
            const params = {
                requestId: this.props.requestId,
                typeDownload: DOWNLOAD_DOCUMENT_BY_REQUEST_AND_ZIP,
                urlPageBeforeDownload: hrefPage,
            };
            window.location =
                BASE_URL + PAGE_DOWNLOAD_REQUEST_DOCUMENT + "?" + qs.stringify(params);
        } else {
            this.downloadFileAction(requestDocumentList[0]);
        }
    }

    getTypeAnSubTypeFromMimeType = (mimeType) => {
        if (mimeType) {
            const indexSlash = mimeType.indexOf("/");
            return {
                fileType: mimeType.substring(0, indexSlash !== -1 ? indexSlash : 0),
                fileSubType: mimeType.substring(indexSlash !== -1 ? indexSlash + 1 : 0),
            };
        }
        return {
            fileType: "",
            fileSubType: "",
        };
    }


    render() {
        const {classes, t, requestDocumentList} = this.props;
        const {
            fileView,
        } = this.state;


        return (
            <div className={classes.filesUploadManager}>

                <div className="listFiles">
                    <div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/*<TableCell width={50}></TableCell>*/}
                                    <TableCell
                                        style={{
                                            minWidth: 180,
                                        }}
                                    >
                                        {this.props.t("requestDocument.label.files")}
                                    </TableCell>
                                    <TableCell>
                                        {this.props.t("requestDocument.label.date")}
                                    </TableCell>
                                    <TableCell/>
                                    <TableCell/>
                                </TableRow>
                            </TableHead>
                            {Array.isArray(requestDocumentList) && requestDocumentList.length > 0 ? (
                                <React.Fragment>
                                    <TableBody>
                                        {requestDocumentList.map((item, index) => {
                                            let {fileType, fileSubType} =
                                                this.getTypeAnSubTypeFromMimeType(item.mimeType);
                                            return (
                                                <TableRow className="notSentTr" key={index}>
                                                    <TableCell className={"columnDocInfoWrapper"}>
                                                        <div className="docInfo">
                                                            <div className="fileView">
                                                                {fileType === FILE_TYPE_VIDEO ? (
                                                                    <div className="video">
                                                                        <a
                                                                            href={item.pathUrl}
                                                                            download
                                                                            target="_blank"
                                                                        >
                                                                            <img src={VideoCategoryIcon} alt=""/>
                                                                        </a>
                                                                    </div>
                                                                ) : fileType === FILE_TYPE_IMAGE ? (
                                                                    <a
                                                                        href={item.pathUrl}
                                                                        download
                                                                        target="_blank"
                                                                    >
                                                                        <img
                                                                            src={item.pathUrl}
                                                                            alt=""
                                                                            className="image"
                                                                        />
                                                                    </a>
                                                                ) : fileType === FILE_TYPE_APPLICATION ? (
                                                                    <React.Fragment>
                                                                        {fileSubType === FILE_SUBTYPE_PDF ? (
                                                                            <a
                                                                                href={item.pathUrl}
                                                                                download
                                                                                target="_blank"
                                                                            >
                                                                                <img src={DocPdfIcon} alt=""/>
                                                                            </a>
                                                                        ) : (
                                                                            <a
                                                                                href={item.pathUrl}
                                                                                download
                                                                                target="_blank"
                                                                            >
                                                                                <img src={DocIcon} alt=""/>
                                                                            </a>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <a
                                                                        href={item.pathUrl}
                                                                        download
                                                                        target="_blank"
                                                                    >
                                                                        <img src={DocIcon} alt=""/>
                                                                    </a>
                                                                )}
                                                            </div>
                                                            <Tooltip title={item.docName} arrow>
                                                                <div className="docName docNameNotEdit">
                                                                    {item.docName ?? ""}
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="dateView">
                                                            {item.createdAt
                                                                ? moment(item.createdAt).format("DD.MM.YYYY")
                                                                : ""}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className="buttonAction">
                                                        <IconButton
                                                            onClick={() => this.downloadFileAction(item)}
                                                        >
                                                            <GetAppIcon/>
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell className="buttonAction">
                                                        <IconButton
                                                            onClick={() => this.viewFileAction(item)}
                                                        >
                                                            <RemoveRedEyeIcon/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </React.Fragment>
                            ) : ""}
                        </Table>
                        {Array.isArray(requestDocumentList) && requestDocumentList.length > 0 ? "" :
                            <div className="noDocument">
                                {this.props.t("text.noResult")}
                            </div>}
                    </div>
                </div>

                {fileView && (
                    <GeneralModal
                        className={classes.previewModal}
                        open={true}
                        handleClose={this.handleCloseModal}
                        content={<ContentPreviewModal2 files={[fileView]} keyFile={0}/>}
                        saveButton={false}
                        cancelButton={false}
                        hasFullscreen={true}
                        hideFooter={true}
                    />
                )}

            </div>
        );
    }
}

RequestDocumentList.defaultProps = {
    requestDocumentList: []
};

RequestDocumentList.propTypes = {
    classes: PropTypes.object.isRequired,
    requestDocumentList: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        dataUser: state.authReducer.dataUser,
        currency: state.applicationReducer.currency,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    withTranslation(),
    withRouter
)(RequestDocumentList);
